// @ts-nocheck
import React from 'react';
import PropTypes from 'react-proptypes';
import { SortContainer } from '../shared/sortable';
import LayerPickerActiveLayersListItem from './layer-picker-active-layers-list-item';

export default class LayerPickerActiveLayersList extends SortContainer {
  static propTypes = {
    filter: PropTypes.string,
    handleLayersClick: PropTypes.func,
  };

  render() {
    return (
      <div
        className={this.props.className}
        ref={this.bindContainer}
      >
        {this.filteredItems.map((item, index) => (
          <LayerPickerActiveLayersListItem
            key={`active-layer-${item.id}`}
            index={index}
            item={item}
            handleLayersClick={this.props.handleLayersClick}
          />
        ))}
      </div>
    );
  }

  get filteredItems() {
    const filter = this.props.filter || '';

    return this.props.items.filter((item) => item.name.toLowerCase().indexOf(filter.toLowerCase()) > -1);
  }

  bindContainer = (node) => {
    this._container = node;
  };

  updateMaxHeight(height) {
    if (this._container) {
      this._container.style.maxHeight = `${height}px`;
    }
  }
}
